import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from 'react';

import { useDisclosure, UseDisclosureReturn } from '@chakra-ui/react';

import { FilterModal } from '../components/FilterModal';

interface FilterModalProviderProps {
  children: ReactNode;
}

interface IFilterModalData extends UseDisclosureReturn {
  selectedFilterId: (value: string) => void;
}

const FilterModalContext = createContext({} as IFilterModalData);

export function FilterModalProvider({ children }: FilterModalProviderProps) {
  const disclosure = useDisclosure();
  const [filterId, setFilterId] = useState<string>('');

  const selectedFilterId = useCallback((value: string) => {
    setFilterId(value);
  }, []);

  return (
    <FilterModalContext.Provider value={{ ...disclosure, selectedFilterId }}>
      {children}
      <FilterModal filterId={filterId} />
    </FilterModalContext.Provider>
  );
}

export const useFilterModal = () => useContext(FilterModalContext);
